import { render, staticRenderFns } from "./AboutGiftTypesSection.vue?vue&type=template&id=0f655d7d&scoped=true&"
import script from "./AboutGiftTypesSection.vue?vue&type=script&lang=js&"
export * from "./AboutGiftTypesSection.vue?vue&type=script&lang=js&"
import style0 from "./AboutGiftTypesSection.vue?vue&type=style&index=0&id=0f655d7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f655d7d",
  null
  
)

export default component.exports